export default __webpack_public_path__ + "static/143-2f04054152e7f584b440589fb82b81b6.jpg";